import { ApolloClient } from '@apollo/client';
import { getApolloClient } from '@zoopla/apollo';
import { AB_TEST_QUERY, GetAbTestsQuery } from '@zoopla/ab-test-queries';
import { logError } from '@zoopla/logger';

export type ABTests = Record<string, string>;

export const getABTests = async (
    client?: ApolloClient<unknown>
): Promise<Record<string, string> | null> => {
    const c = client ?? getApolloClient();
    const {
        data: { abTests },
        errors
    } = await c.query<GetAbTestsQuery>({
        query: AB_TEST_QUERY
    });

    if (errors) {
        logError(errors);
    }

    return (
        abTests?.reduce((acc, { id, name }) => ({ ...acc, [id]: name }), {}) ??
        null
    );
};
